/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Directive, HostListener, Input, OnInit } from '@angular/core'
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms'
import { AnalyticsService } from './@core/utils/analytics.service'
import { SeoService } from './@core/utils/seo.service'
import { FFService } from './ff/ff.service'
import { ApplicationService } from './ff/services/application/application.service'
import { NotificationService } from './ff/services/notification/notification.service'
import { SessionTimeoutService } from './ff/services/session_timeout/session_timeout.service'

@Directive( {
  selector: '[requiredArray][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: RequiredArrayDirective, multi: true }]
} )
export class RequiredArrayDirective implements Validator {
  @Input( 'requiredArray' ) requiredArray = false;

  validate ( control: AbstractControl ) {
    // Debug log
    console.log( '[requiredArray] validator runs. value:', control.value, 'required:', this.requiredArray )

    if ( !this.requiredArray ) { return null }
    const value = control.value
    return Array.isArray( value ) && value.length > 0 ? null : { required: true }
  }
}
@Component( {
  selector: 'ff-app',
  template: '<router-outlet></router-outlet>',
} )
export class AppComponent implements OnInit {
  services

  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private ff_service: FFService,
    private application_service: ApplicationService,
    private notification_service: NotificationService,
    private session_timeout_service: SessionTimeoutService ) {
    // Linter complains if we don't use the services but we need them here to start them.
    // this.services is just to stop linter complaints
    this.services = [this.ff_service, this.notification_service]
  }

  ngOnInit (): void {
    this.analytics.trackPageViews()
    this.seoService.trackCanonicalChanges()
  }

  @HostListener( 'window:mousemove' ) refreshUserState () {
    this.session_timeout_service.user_interacted()
    // this.session_timeout_service.reset_session_timer();
  }

  @HostListener( 'window:scroll', ['$event'] ) onWindowScroll ( $event ) {
    this.session_timeout_service.user_interacted()
    // this.session_timeout_service.reset_session_timer();
  }
}
